import Button from 'components/_parts/atoms/button';
import Label from 'components/_parts/atoms/label';
import TooltipCustom from 'components/_parts/atoms/tooltip';
import { processLabel } from 'components/types/businessProcess';
import labelBp from './label';

function Support({ val, setSelectedData }: processLabel) {
  const labelSupport = labelBp('support');
  return (
    <div
      id="cvc-support"
      key={val.process_id}
      className="custm_list_cvc gap20Cvc pointer"
      aria-hidden="true"
      onClick={() => {
        setSelectedData({
          lvl: '2',
          process_id: val.process_id,
          type: labelSupport,
          backgroundColor: '#FFDF32',
          name: val.name,
          order: val.order,
        });
      }}
    >
      <Button
        style={{
          width: '28px',
          height: '28px',
          backgroundColor: '#FFDF32',
          boxShadow: '0 4px 4px 0 rgba(0,0,0,0.3)',
        }}
      >
        {val.no}
      </Button>
      <TooltipCustom name={val?.name}>
        <Label className="clampTitle">{val?.name}</Label>
      </TooltipCustom>
      <Button
        style={{
          backgroundColor: '#FFDF32',
          height: '20px',
          padding: '0px 20px',
          fontWeight: '600',
          marginLeft: 'auto',
        }}
      >
        {labelSupport}
      </Button>
    </div>
  );
}

export default Support;
